import { render, staticRenderFns } from "./chat-new.vue?vue&type=template&id=5fbc8046&scoped=true"
import script from "./chat-new.vue?vue&type=script&lang=js"
export * from "./chat-new.vue?vue&type=script&lang=js"
import style0 from "./chat-new.vue?vue&type=style&index=0&id=5fbc8046&prod&lang=css"
import style1 from "./chat-new.vue?vue&type=style&index=1&id=5fbc8046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc8046",
  null
  
)

export default component.exports